module.exports = "/_next/static/images/GetHistory-18e9a793f48c1e17cf612ef7541789f9.webp";